import { Component, EventEmitter, inject, input, Output } from '@angular/core';
import { TemporaryArea } from '@models/map/market-filter.model';
import { EvAreaType } from 'src/app/infopage/models/area-type.enum';
import { AreaBuilderUtils } from 'src/util/map/areabuilder.util';

@Component({
  selector: 'area-list-item',
  templateUrl: './area-list-item.component.html',
  styleUrl: './area-list-item.component.scss',
})
export class AreaListItemComponent {
    area = input<TemporaryArea>();
    @Output() onRemove = new EventEmitter<TemporaryArea>();

    EvAreaType = EvAreaType;
    private areaBuilderUtils = inject(AreaBuilderUtils);

    getMappedType(areaTypeId: number) {
        return this.areaBuilderUtils.getAreaTypeNameSingular(areaTypeId);
    }

    onClickEvent(): void {

    }
}
